import {
    PRE_ADD_DATA_SUCCESS,
    PRE_ADD_DATA_FAIL,
    ADD_PRODUCT_FAIL,
    ADD_PRODUCT_SUCCESS,
    DELETE_PRODUCT_FAIL,
    DELETE_PRODUCT_SUCCESS,
    DELETE_BULK_PRODUCT_FAIL,
    DELETE_BULK_PRODUCT_SUCCESS,
    EXPORT_PRODUCT_FAIL,
    EXPORT_PRODUCT_SUCCESS,
    IMPORT_PRODUCT_FAIL,
    IMPORT_PRODUCT_SUCCESS,
    IMPORT_PRODUCT_IMAGE_FAIL,
    IMPORT_PRODUCT_IMAGE_SUCCESS,
    GET_PRODUCT_DETAILS_FAIL,
    GET_PRODUCT_DETAILS_SUCCESS,
    GET_PRODUCT_LISTING_FAIL,
    GET_PRODUCT_LISTING_SUCCESS,
    GET_PRODUCT_LISTING_FOR_GIFT_FAIL,
    GET_PRODUCT_LISTING_FOR_GIFT_SUCCESS,
    GET_PRODUCT_LISTING_FOR_ACCESORIES_FAIL,
    GET_PRODUCT_LISTING_FOR_ACCESORIES_SUCCESS,
    RESET_PRODUCT_STATE,
    RESET_IMPORT_STATE,
    UPDATE_PRODUCT_FAIL,
    UPDATE_PRODUCT_SUCCESS,
    APPROVE_REJECT_PRODUCT_FAIL,
    APPROVE_REJECT_PRODUCT_SUCCESS,
    BULK_ATTACH_PDF_SUCCESS,
    BULK_ATTACH_PDF_FAIL,
} from "./actionTypes"

const INIT_STATE = {
    preAddData: [],
    productListing: [],
    productListingForGift: [],
    productListingForAccesories: [],
    productDetails: [],
    addProduct: [],
    updateProduct: [],
    approveRejectProductState: [],
    deleteProduct: [],
    exportProduct: [],
    importProductImage: [],
    bulkAttachPdf: [],
    error: [],
}

const Product = (state = INIT_STATE, action) => {
    switch (action.type) {
        case PRE_ADD_DATA_SUCCESS:
            return {
                ...state,
                preAddData: action.payload
            }
        case PRE_ADD_DATA_FAIL:
            return {
                ...state,
                preAddData: action.payload
            }
        case GET_PRODUCT_LISTING_SUCCESS:
            return {
                ...state,
                productListing: action.payload
            }
        case GET_PRODUCT_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            }
        case GET_PRODUCT_LISTING_FOR_GIFT_SUCCESS:
            return {
                ...state,
                productListingForGift: action.payload
            }
        case GET_PRODUCT_LISTING_FOR_GIFT_FAIL:
            return {
                ...state,
                error: action.payload,
            }
        case GET_PRODUCT_LISTING_FOR_ACCESORIES_SUCCESS:
            return {
                ...state,
                productListingForAccesories: action.payload
            }
        case GET_PRODUCT_LISTING_FOR_ACCESORIES_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_PRODUCT_DETAILS_SUCCESS:
            return {
                ...state,
                productDetails: action.payload
            }
        case GET_PRODUCT_DETAILS_FAIL:
            return {
                ...state,
                error: action.payload,
                productDetails: action.payload
            }

        case ADD_PRODUCT_SUCCESS:
            return {
                ...state,
                addProduct: action.payload
            }
        case ADD_PRODUCT_FAIL:
            return {
                ...state,
                addProduct: action?.payload,
                error: action.payload,
            }

        case UPDATE_PRODUCT_SUCCESS:
            return {
                ...state,
                updateProduct: action.payload
            }
        case UPDATE_PRODUCT_FAIL:
            return {
                ...state,
                updateProduct: action?.payload,
                error: action.payload,
            }

        case APPROVE_REJECT_PRODUCT_SUCCESS:
            return {
                ...state,
                approveRejectProductState: action.payload
            }
        case APPROVE_REJECT_PRODUCT_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case DELETE_PRODUCT_SUCCESS:
            return {
                ...state,
                deleteProduct: action.payload
            }
        case DELETE_PRODUCT_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case DELETE_BULK_PRODUCT_SUCCESS:
            return {
                ...state,
                deleteBulkProduct: action.payload
            }
        case DELETE_BULK_PRODUCT_FAIL:
            return {
                ...state,
                error: action.payload,
                deleteBulkProduct: action.payload,
            }

        case EXPORT_PRODUCT_SUCCESS:
            return {
                ...state,
                exportProduct: action.payload
            }
        case EXPORT_PRODUCT_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case IMPORT_PRODUCT_SUCCESS:
            return {
                ...state,
                importProduct: action.payload
            }
        case IMPORT_PRODUCT_FAIL:
            return {
                ...state,
                error: action.payload,
                importProduct: action.payload
            }
        case IMPORT_PRODUCT_IMAGE_SUCCESS:
            return {
                ...state,
                importProductImage: action.payload
            }
        case IMPORT_PRODUCT_IMAGE_FAIL:
            return {
                ...state,
                error: action.payload,
                importProductImage: action.payload
            }
        case BULK_ATTACH_PDF_SUCCESS:
            return {
                ...state,
                bulkAttachPdf: action.payload,
            }
        case BULK_ATTACH_PDF_FAIL:
            return {
                ...state,
                error: action.payload,
                bulkAttachPdf: action.payload,
            }

        case RESET_IMPORT_STATE:
            return {
                ...state,
                error: [],
                importProduct: [],
                importProductImage: [],
                deleteBulkProduct: [],
                bulkAttachPdf: [],
            }

        case RESET_PRODUCT_STATE:
            return {
                ...state,
                preAddData: [],
                productListing: [],
                productListingForGift: [],
                productListingForAccesories: [],
                productDetails: [],
                addProduct: [],
                updateProduct: [],
                approveRejectProductState: [],
                deleteProduct: [],
                deleteBulkProduct: [],
                exportProduct: [],
                importProduct: [],
                bulkAttachPdf: [],
                error: [],
            }
        default:
            return state
    }
}

export default Product
